import { Loading } from "components/shared";
import React, { useEffect } from "react";
import useMagicAction, { RESULT_SCHEMA, asText } from "./useMagicAction";


const ContinueWriting = (props) => {

    const { run, writeBackInsert, closeMenu } = useMagicAction(props);
    const { selectedText, fullText, selectionStartEnd } = props;

    useEffect(() => {
        const given = selectedText ? selectedText : fullText.substring(0, selectionStartEnd.finish);
        run({
            prompt: `Continue writing from where the text ends. Write about 200 characters. Do NOT repeat the given text.\n\nTEXT:\n${given}`,
            schema: RESULT_SCHEMA,
        })
            .then((r) => writeBackInsert(asText(r)))
            .finally(closeMenu);
    }, []);

    return (
        <div className="flex items-center justify-center p-4 gap-2">
            <Loading type={'element'} />
        </div>
    )
}

export default ContinueWriting;
